import { Grid, GridColumn as Column, GridToolbar  } from "@progress/kendo-react-grid";
import React, {  useState } from 'react'; 
import comdetailsdata from '../data/comdetailsdata.json';
const ADJUST_PADDING = 1;
const COLUMN_MIN = 6;

const columns = [
    {
      field: "currentperiodstartdate",
      title: comdetailsdata.gridColumns[0],
      minWidth: 100,
    },
    {
      field: "currentperiodenddate",
      title: comdetailsdata.gridColumns[1],
      minWidth: 100,
    },
    {
      field: "isaudited",
      title: comdetailsdata.gridColumns[2],
      minWidth: 80,
    },
    {
      field: "currency_code",
      title: comdetailsdata.gridColumns[3],
      minWidth: 80,
    },
    {
      field: "companyrevenue",
      title: comdetailsdata.gridColumns[4],
      minWidth: 100,
    },
    {
        field: "companyprofitlossaftertax",
        title: comdetailsdata.gridColumns[5],
        minWidth: 100,
      },
  ];

const FinancialHighlights = (props) => {
    const {minData, maxData } = props;
    const [showMore,setShowMore] = useState(false);
 
    const handleOnClick = () => {
        setShowMore(!showMore);
    }

    const minGridWidth = React.useRef(0);
    const grid = React.useRef(null);
 
    const [applyMinWidth, setApplyMinWidth] = React.useState(false);
    const [gridCurrent, setGridCurrent] = React.useState(0);

    React.useEffect(() => {
        grid.current = document.querySelector(".k-grid");
        window.addEventListener("resize", handleResize);
        columns.map((item) =>
          item.minWidth !== undefined
            ? (minGridWidth.current += item.minWidth)
            : minGridWidth.current
        );
        setGridCurrent(grid.current.offsetWidth);
        setApplyMinWidth(grid.current.offsetWidth < minGridWidth.current);
    }, []);

    const handleResize = () => {
        if (grid.current.offsetWidth < minGridWidth && !applyMinWidth) {
          setApplyMinWidth(true);
        } else if (grid.current.offsetWidth > minGridWidth) {
          setGridCurrent(grid.current.offsetWidth);
          setApplyMinWidth(false);
        }
    };

    const setWidth = (minWidth) => {
        if(minWidth === undefined) {
            minWidth = 0;
        }

        let width = applyMinWidth
          ? minWidth
          : minWidth + (gridCurrent - minGridWidth.current) / columns.length;
        if(width < COLUMN_MIN) {
            width =width;
        } else {
            (width -= ADJUST_PADDING);
        }
        return width;
    };
    
    return(
        <div>
            <div style={{width:'100%'}} >
                <Grid data={showMore? maxData:minData} scrollable={'scrollable'} resizable={false}>
                    {/* <Column title={comdetailsdata.gridColumns[0]} field="currentperiodstartdate" /> 
                    <Column title={comdetailsdata.gridColumns[1]} field="currentperiodenddate" /> 
                    <Column title={comdetailsdata.gridColumns[2]} field="isaudited"    />
                    <Column title={comdetailsdata.gridColumns[3]} field="currency_code"   />
                    <Column title={comdetailsdata.gridColumns[4]} field="companyrevenue"  />
                    <Column title={comdetailsdata.gridColumns[5]} field="companyprofitlossaftertax"   /> */}
                    {columns.map((column, index) => {
                        return (
                        <Column
                            field={column.field}
                            title={column.title}
                            key={index}
                            width={setWidth(column.minWidth)}
                        />
                        );
                    })}
               
                    <GridToolbar>
                     {(minData && minData.length > 1)&&
                        <span className="k-space-left" style={{fontSize: "14px",position:'absolute',right:'0'}} 
                            onClick={handleOnClick}>
                            Click to see more
                            {!showMore?
                            <span className="k-icon k-i-arrow-chevron-down" />:
                            <span className="k-icon k-i-arrow-chevron-up" />
                            }
                        </span>
                     }
                    </GridToolbar>
              
                </Grid> 
            </div>
        </div>
     
    )
}

export default FinancialHighlights
